/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>


module Meevo.Plugins.YieldManagementStrategy {

  /**
  * Main Section of Work Activities
  */
    export class YieldManagerStrategyMainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<IYMStrategy> {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            protected identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, null, sectionSecurityKey);

        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data: IYMStrategy) => {
                this.model = data;
            });
        }

        openSelectLocations() {
            this.modalService.showCustom({
                templateUrl: 'app/plugins/yieldManagementStrategy/components/locations-selector/locations-selector.template.html',
                clickOutsideToClose: false,
                locals: {
                    selectedItems: this.model.locations,
                },
                controller: 'meevo.plugins.yieldManagementStrategy.LocationSelector',
                controllerAs: 'ctrl'
            }).then((res: number[]) => {
                this.model.locations = [...res];
            });
        }
    }
}
